import { Avatar, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectStudent } from "../../../redux/student/studentSlice";
import { styled } from "@mui/material/styles";
import { stringAvatar, stringToColor } from "../../../features/user/avatarUtils";
import { assertThumbnailUrl } from "../../../redux/common";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
  fontSize: "0.5rem",
}));

interface StudentPageAvatarProps {
}

const StudentPageAvatar = ({}: StudentPageAvatarProps) => {
  const student = useSelector( selectStudent );

  return student.selected ?
    <Box sx={{ mr: 2 }}>
        <Avatar sx={{ backgroundColor: stringToColor(student.selected.name) }} alt={`${student.selected.name}`} src={`${assertThumbnailUrl(student.selected.url)}`}>
        <Typography variant="h6" component="span">
          {stringAvatar(student.selected.name)}
        </Typography>
      </Avatar>
    </Box>
    : <></>;
};

export default StudentPageAvatar;